const CORS_PROXY = "https://corsproxy.io/?";

export const LOGO_URL = "https://t3.ftcdn.net/jpg/01/31/19/42/360_F_131194206_jk113fvl8oFmeAHSWzDyhRJIkiBmnNaN.jpg";
export const CONTACT_URL = "https://image.shutterstock.com/image-vector/contact-us-concept-icon-information-260nw-1212067657.jpg"

export const IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";


export const SWIGGY_API_URL =
  CORS_PROXY +
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING";

export const ErrorUrl = "https://i.pinimg.com/originals/30/32/96/303296521d256bfbb17f76c3b3592738.png";

export const swiggy_menu_api_URL =
"https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&&submitAction=ENTER&restaurantId="


export const MENU_ITEM_TYPE_KEY = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
export const RESTAURANT_TYPE_KEY = "type.googleapis.com/swiggy.presentation.food.v2.Restaurant";
export const ITEM_IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";